<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <div v-if="!existsAnswered">
      <v-container
        class="mx-auto mt-6"
        style="max-width: 1200px;"
      >
        <progress-components page="info"></progress-components>
        <v-form ref="form" class="mt-12">
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>氏名</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
              <v-responsive
                class="mx-5"
                max-width="344"
              >
                <v-text-field
                  label="回答を入力"
                  variant="underlined"
                  :rules="[required]"
                  v-model="name"
                ></v-text-field>
              </v-responsive>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>フリガナ</strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
              <v-responsive
                class="mx-5"
                max-width="344"
              >
                <v-text-field
                  label="回答を入力"
                  variant="underlined"
                  :rules="[required, kanaText]"
                  v-model="kana"
                ></v-text-field>
              </v-responsive>
          </v-card>
          <v-card
            class="mx-auto mt-6"
            elevation="1"
            outlined
          >
            <v-card-title>
              <strong>年齢属性 </strong><span class="text-red"><strong> *</strong></span>
            </v-card-title>
            <v-radio-group
              v-model="age"
              class="mx-2 mb-4"
              :rules="[required]"
            >
              <v-radio class="mt-2" v-for="item in selectAges" :key="item" :label="item" :value="item" color="doorMainColor"></v-radio>
            </v-radio-group>
          </v-card>
          <div v-show="isUnderage">
            <v-card
              class="mx-auto mt-6"
              elevation="1"
              outlined
            >
              <v-card-title>
                <strong>13歳以上18歳未満の方</strong>
              </v-card-title>
              <div class="mx-5 mb-5">13歳以上18歳未満を選択した方はご記入ください。ご記入がない場合には診療をお受けできません。</div>
            </v-card>
            <v-card
              class="mx-auto mt-6"
              elevation="1"
              outlined
            >
              <v-card-title>
                <strong>保護者の名前</strong><span class="text-red"><strong> *</strong></span>
              </v-card-title>
                <v-responsive
                  class="mx-5"
                  max-width="344"
                >
                  <v-text-field
                    label="回答を入力"
                    variant="underlined"
                    :rules="[requiredIfNeeded(isUnderage)]"
                    v-model="nameOfParent"
                  ></v-text-field>
                </v-responsive>
            </v-card>
            <v-card
              class="mx-auto mt-6"
              elevation="1"
              outlined
            >
              <v-card-title>
                <strong>保護者の電話番号</strong><span class="text-red"><strong> *</strong></span>
              </v-card-title>
                <v-responsive
                  class="mx-5"
                  max-width="344"
                >
                  <v-text-field
                    label="回答を入力"
                    variant="underlined"
                    type="text"
                    maxLength=15
                    counter="15"
                    :rules="[telNumberOfParent(isUnderage)]"
                    v-model="telOfParent"
                  ></v-text-field>
                </v-responsive>
            </v-card>
          </div>
          <v-card
            class="mx-auto mt-6 my-10"
            elevation="1"
            outlined
          >
            <div class="my-10">以下をお持ちの方で受信者登録画面での画像登録がお済みでない方は該当項目にチェックの上、アプリ内での画像送信をお願いします。</div>
              <v-item-group
                class="mx-2"
              >
              <v-row v-for="(item, index) in selectCertificates" :key="index">
                <v-col class="py-0">
                  <v-checkbox
                    :label="item"
                    :value="item"
                    class="py-0 mt-0 mb-5"
                    dense
                    color="doorMainColor"
                    :hide-details="index !== (selectCertificates.length - 1)"
                    v-model="certificates"
                    :rules="[requiredMultipleSelect]"
                  >
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-item-group>
          </v-card>
        </v-form>
      </v-container>
      <v-container class="mx-auto mt-0">
        <v-row justify="center" align-content="center" class="mb-6 btn-area">
          <v-btn
              x-large min-width="362px"
              color="doorAccentColor"
              class="mb-4 white--text"
              @click="clickedConfirm"
          >
            <span v-if='fromConfirm'>確認</span>
            <span v-else>次へ</span>
          </v-btn>
        </v-row>
      </v-container>
    </div>
    <v-container
      v-else
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <v-row no-gutters justify="center" align-content="center">
        <span class="font-weight-bold text-body-1">すでに事前問診回答済みとなります。</span>
      </v-row>
    </v-container>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, ref, computed, watch } from 'vue'
import { Logger } from 'aws-amplify'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'
import { useFormValidator } from '@/func/useFormValidator'
import { useScreenOperation } from '@/func/useScreenOperation'
import { useApiParams } from '@/func/useApiParams';
import { usePostMessage } from '@/func/usePostMessage';

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents
  },
  setup() {
    logger.info('Advance form')
    const { scrollToErrorPosition, scrollToTop, fromConfirmScreen } = useScreenOperation()
    scrollToTop()
    const store = useStore()

    // すでに回答済みかどうか確認処理
    const getExistsAnswered = async () => {
      try {
        const treatmentConsultationSeq = store.getters["apiParams/treatmentConsultationSeq"]
        const jwtToken = store.getters["apiParams/jwtToken"]
        await store.dispatch('advanceInterview/getInterview', { treatmentConsultationSeq, jwtToken })
      } catch (e) {
        logger.info(e);
      }
    }
    // 回答済みの事前問診有無
    const existsAnswered = computed(() => {
      return store.getters['advanceInterview/id'] !== '';
    });

    // トークンの状態監視
    const token = computed({ get: () => store.state.apiParams.jwtToken })
    watch(token, (value) => {
      logger.info('Updated JWT', value)
      logger.info('It,s time to run the API!!')
      // すでに回答済みであれば取得する
      getExistsAnswered();
    })
    // トークン保存処理
    useApiParams().save()
    usePostMessage().receiveToken()

    const fromConfirm = computed(() => fromConfirmScreen())
    const name = computed({
      get: () => store.state.advanceInterview.name,
      set: (value) => store.dispatch('advanceInterview/setName', value)
    })
    const kana = computed({
      get: () => store.state.advanceInterview.kana,
      set: (value) => store.dispatch('advanceInterview/setKana', value)
    })
    const age = computed({
      get: () => store.state.advanceInterview.age,
      set: (value) => store.dispatch('advanceInterview/setAge', value)
    })
    const otherAge = computed({
      get: () => store.state.advanceInterview.otherAge,
      set: (value) => store.dispatch('advanceInterview/setOtherAge', value)
    })
    const nameOfParent = computed({
      get: () => store.state.advanceInterview.nameOfParent,
      set: (value) => store.dispatch('advanceInterview/setNameOfParent', value)
    })
    const telOfParent = computed({
      get: () => store.state.advanceInterview.telOfParent,
      set: (value) => store.dispatch('advanceInterview/setTelOfParent', value)
    })
    const certificates = computed({
      get: () => store.state.advanceInterview.certificates,
      set: (value) => store.dispatch('advanceInterview/setCertificates', value)
    })
    const selectAges = ref([
      '13歳未満',
      '13歳以上18歳未満',
      '18歳以上64歳以下',
      '65歳以上'
    ])
    const selectCertificates = ref([
      'こども医療証',
      'ひとり親家庭医療費受給者証',
      '休日夜間等診療依頼証',
      'なし',
      '現在手元にない'
    ])
    const form = ref(null)
    const { required, requiredOtherText, requiredMultipleSelect, requiredOtherTextMultipleSelect, requiredIfNeeded, kanaText, telNumberOfParent } = useFormValidator()
    const isUnderage = computed(() => age.value === '13歳以上18歳未満')
    const isOutOfAge = computed(() => age.value === '13歳未満' || age.value === '65歳以上')

    const router = useRouter()
    const clickedConfirm = async () => {
      const result = await form.value.validate()
      if (!result.valid) {
        scrollToErrorPosition()
        return
      }
      if (isOutOfAge.value) {
        router.push({ name: 'AdvanceInterviewCancel', params: {
          code: 101,
          page: 'info'
        }})
        return
      }
      if (fromConfirm.value) {
        router.push('/interview/confirm')
      } else {
        router.push('/interview/risk')
      }
    }
    return {
      age,
      otherAge,
      name,
      kana,
      certificates,
      nameOfParent,
      telOfParent,
      selectAges,
      selectCertificates,
      isUnderage,
      form,
      required,
      requiredIfNeeded,
      requiredOtherText,
      requiredOtherTextMultipleSelect,
      requiredMultipleSelect,
      clickedConfirm,
      fromConfirm,
      kanaText,
      telNumberOfParent,
      existsAnswered,
    }
  }
})
</script>

<style scoped>
.v-input :deep(.v-label) {
  color: rgba(0, 0, 0, .87) !important;
}
.v-card__title {
  font-weight: bold;
  white-space: inherit !important;
}

@media screen and (max-width: 960px) {
  .btn-area button{
    min-width: 55%!important;
  }
}

</style>
